import { useEffect, useState } from "react";
import _ from "lodash";
import TagManager from "react-gtm-module";
import { createDataLayerUpdates, getClientUserInfo }  from "../utils/utils";
import { GTMDataLayer } from "../adapters/types";
import { defaultGtmDataLayer, gtmId } from "../common/constants";
import useUserInfo from "./useUserInfo";



export const isDataLayerReady = (dataLayer: GTMDataLayer): boolean =>
  dataLayer.d_user_id !== "" &&
  dataLayer.d_company_id !== "" &&
  dataLayer.d_company_name !== "" &&
  dataLayer.d_company_access !== "" &&
  dataLayer.d_enterprise_id !== "" &&
  dataLayer.d_department_id !== "" &&
  dataLayer.d_user_roles.length > 0;

export const areDataLayersEqual = (
  dataLayer1: GTMDataLayer,
  dataLayer2: GTMDataLayer
): boolean =>
  _.isEqual(dataLayer1.d_user_id, dataLayer2.d_user_id) &&
  _.isEqual(dataLayer1.d_company_id, dataLayer2.d_company_id) &&
  _.isEqual(dataLayer1.d_company_name, dataLayer2.d_company_name) &&
  _.isEqual(dataLayer1.d_company_access, dataLayer2.d_company_access) &&
  _.isEqual(dataLayer1.d_enterprise_id, dataLayer2.d_enterprise_id) &&
  _.isEqual(dataLayer1.d_department_id, dataLayer2.d_department_id) &&
  _.isEqual(dataLayer1.d_user_roles, dataLayer2.d_user_roles);

export const gtmInitialization =(initializedGtmDataLayer: GTMDataLayer, localGtmDataLayer: GTMDataLayer, setInitializedGtmDataLayer: (data: GTMDataLayer) => void): void => {

  if (window.dataLayer &&
    isDataLayerReady(initializedGtmDataLayer) &&
    !areDataLayersEqual(localGtmDataLayer, initializedGtmDataLayer)) {

    TagManager.initialize({
      gtmId,
      dataLayer: localGtmDataLayer,
    });
    setInitializedGtmDataLayer(localGtmDataLayer);
  }
}

 export const useInitializeGoogleTagManager = (
    selectedStore: any | undefined
  ): void => {
    const [localGtmDataLayer, setLocalGtmDataLayer] =
      useState<GTMDataLayer>(defaultGtmDataLayer);
    const [initializedGtmDataLayer, setInitializedGtmDataLayer] =
      useState<GTMDataLayer>(defaultGtmDataLayer); 
      const {userInfo :client} = useUserInfo();  
    const userInfo = getClientUserInfo(client,selectedStore);
    
  useEffect(() => {
    const updates = createDataLayerUpdates(localGtmDataLayer, userInfo);
      if (Object.keys(updates).length > 0) {
      setLocalGtmDataLayer((prevDataLayer:GTMDataLayer)  => ({
        ...prevDataLayer,
        ...updates,
      }));
    }
  }, [userInfo, localGtmDataLayer]);

  useEffect(() => {
    if (window.dataLayer && isDataLayerReady(localGtmDataLayer)) {
      TagManager.initialize({
        gtmId,
        dataLayer: localGtmDataLayer,
      });
      setInitializedGtmDataLayer(localGtmDataLayer);
    }
  }, [localGtmDataLayer]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      gtmInitialization(initializedGtmDataLayer, localGtmDataLayer, setInitializedGtmDataLayer);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [localGtmDataLayer, initializedGtmDataLayer]);
};



 
